// extracted by mini-css-extract-plugin
export default {"block":"LoadingPostsBlocks_block__G8sm4","icon":"LoadingPostsBlocks_icon__EPa9-","check":"LoadingPostsBlocks_check__tuQ67","loader":"LoadingPostsBlocks_loader__QARn4"};